<div class="spinner-div">
  <mat-progress-spinner class="spinner" [color]="color" [mode]="mode"></mat-progress-spinner>
</div>
